import { RootState } from '../index';

const getSheets = (state: RootState) => state.sheetsReducer.sheets;

const getSelectedMember = (state: RootState) => state.sheetsReducer.selectedMember;

const getSelectedShift = (state: RootState) => state.sheetsReducer.selectedShift;

const getIsOpenDeleteShiftDialog = (state: RootState) => state.sheetsReducer.isOpenDeleteShiftDialog;

const getIsOpenEmployeesExportMode = (state: RootState) => state.sheetsReducer.isOpenEmployeesExportMode;

const getSelectedMembers = (state: RootState) => state.sheetsReducer.selectedMembers;

const getFilteredSheets = (state: RootState) => state.sheetsReducer.filteredSheets;

const getSelectedLocationId = (state: RootState) => state.sheetsReducer.selectedLocationId;

export {
  getSheets,
  getSelectedMember,
  getSelectedShift,
  getIsOpenDeleteShiftDialog,
  getIsOpenEmployeesExportMode,
  getSelectedMembers,
  getFilteredSheets,
  getSelectedLocationId,
};
